import { EmailModalForm } from "./EmailModalForm";

const EmailModalFormWrapper = ({
  cycleId,
  onClose,
}) => {
  return (
    <EmailModalForm
      cycleId={cycleId}
      onClose={onClose}
    />
  );
};

export { EmailModalFormWrapper };
